import { useStore } from '../../hooks/useStore';

export function StoreSelector() {
  const { stores, activeStore, setActiveStore } = useStore();

  return (
    <div className="relative">
      <select
        value={activeStore.shop}
        onChange={(e) => {
          const s = stores.find((st) => st.shop === e.target.value);
          if (s) setActiveStore(s);
        }}
        className="appearance-none bg-white border border-[var(--ccb-border)] rounded-lg px-3 py-1.5 pr-8 text-sm font-medium text-[var(--ccb-text)] cursor-pointer hover:border-[var(--ccb-primary)] transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--ccb-primary)]/30"
      >
        {stores.map((s) => (
          <option key={s.shop} value={s.shop}>
            {s.shortCode} — {s.label}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-[var(--ccb-text-secondary)]">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </div>
    </div>
  );
}
